import {
    QUEST_RULES,
    QUEST_SQUAD,
    QUEST_STATUSES,
} from '../components/clan_quests_constants'
import { toPythonTS } from 'utils/time'
import { ONE_HOUR, ONE_SECOND } from 'constants'

export const clan_supply_quests_info_mock = (isRewardsTaken = false) => ({
    enabled: true,
    cycle_duration: 24,
    cycle_end: toPythonTS(Date.now() + (2 * ONE_HOUR) + (3 * ONE_SECOND)),
    previous_rewards: {
        tourcoin: isRewardsTaken ? 0 : 100,
        industrial_resource:  isRewardsTaken ? 0 : 200,
    },
    quest_info: [
        {
            name: 'ClanSupplyFragsLevel1',
            current_progress: 3,
            required_progress: 3,
            status: QUEST_STATUSES.COMPLETE,
            conditions: {
                main: {
                    rule: {
                        type: QUEST_RULES.FULL_DAMAGE,
                        full_damage: 2000,
                    },
                    squad_states: [QUEST_SQUAD.PLATOON, QUEST_SQUAD.SOLO],
                    is_clan_squad: false,
                },
                alternative: {
                    rule: {
                        type: QUEST_RULES.WIN,
                    },
                    squad_states: [QUEST_SQUAD.DETACHMENT],
                    is_clan_squad: false,
                },
                common: {
                    level_from: 6,
                    level_to: 10,
                },
            },
            rewards: {
                tourcoin: 500,
                industrial_resource: 250,
            },
        },
        {
            name: 'ClanSupplyFragsLevel2',
            current_progress: 3,
            required_progress: 3,
            status: QUEST_STATUSES.COMPLETE,
            conditions: {
                main: {
                    rule: {
                        type: QUEST_RULES.EXP,
                        exp_earned: 2500,
                    },
                    squad_states: [QUEST_SQUAD.PLATOON, QUEST_SQUAD.SOLO],
                    is_clan_squad: false,
                },
                alternative: {
                    rule: {
                        type: QUEST_RULES.WIN,
                    },
                    squad_states: [QUEST_SQUAD.DETACHMENT],
                    is_clan_squad: false,
                },
                common: {
                    level_from: 6,
                    level_to: 10,
                },
            },
            rewards: {
                tourcoin: 500,
                industrial_resource: 250,
            },
        },
        {
            name: 'ClanSupplyFragsLevel3',
            current_progress: 1,
            required_progress: 3,
            status: QUEST_STATUSES.INCOMPLETE,
            conditions: {
                main: {
                    rule: {
                        type: QUEST_RULES.FRAGS,
                        frags_count: 3,
                    },
                    squad_states: [QUEST_SQUAD.SOLO],
                    is_clan_squad: false,
                },
                alternative: {
                    rule: {
                        type: QUEST_RULES.WIN,
                    },
                    squad_states: [QUEST_SQUAD.DETACHMENT],
                    is_clan_squad: false,
                },
                common: {
                    level_from: 6,
                    level_to: 10,
                },
            },
            rewards: {
                tourcoin: 500,
                industrial_resource: 250,
            },
        },
    ],
})



// WEBPACK FOOTER //
// ./containers/ClanLanding/mocks/clan_supply_quests_info_mock.js